import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  display: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
}));

export default useStyles;
